const routes = {
  reservations: 'Ordens',
};

export default routes;
